export default __webpack_public_path__ + "dda5fd1b25e27b094869bacd54a97482.png";